import { render, staticRenderFns } from "./CompanyUserModal.vue?vue&type=template&id=475811cc&scoped=true"
import script from "./CompanyUserModal.vue?vue&type=script&lang=ts"
export * from "./CompanyUserModal.vue?vue&type=script&lang=ts"
import style0 from "./CompanyUserModal.vue?vue&type=style&index=0&id=475811cc&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "475811cc",
  null
  
)

export default component.exports